import { defineStore } from "pinia";

type IncognitoStoreType = {
  path?: string;
  userId?: number;
};

export const useIncognitoStore = defineStore("incognito", {
  state: (): IncognitoStoreType => {
    return {
      path: undefined,
      userId: undefined,
    };
  },
  actions: {
    start(userId: number) {
      this.path = window.location.href;
      this.userId = userId;
    },
  },
  persist: true,
});
